import React, {useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import * as THREE from "three"
import { useFBO } from '@react-three/drei';
import { useFrame } from '@react-three/fiber';
import AstaSostegno from './AstaSostegno';
import KitPortaCristal from './KitPortaCristal';
import { paraventiConfiguration } from '../Utils/meshesConfiguration';
import { ombrelloniConfiguration } from '../Utils/meshesConfiguration';
import { showMessage, deleteMessage } from "../../Redux/UIMenus/uiDetailsConsoleMenuSlice"
import { E_GenereOmbrellone, E_MainLato, E_TipoOmbrellone } from '../Utils/enumerations';
import { handleTotaleSostegni } from '../../Redux/UIMenus/uiLateraleCristalMenuSlice';

// Laterale Cristal
export default function Cristal() {
    const lunghezza = useSelector(state => state.uiMainMenu.lunghezza) * 1;
    const larghezza = useSelector(state => state.uiMainMenu.larghezza) * 1;
    const latoIngresso = useSelector(state => state.uiMainMenu.ingresso);
    const isCristalSelected = useSelector(state => state.uiCristalMenu.isVisible);
    const latiCristal = useSelector(state => state.uiCristalMenu.latiCristal);
    const isPortaCristalSelected = useSelector(state => state.uiCristalMenu.kitPortaCristal);
    const isPedanaVisible = useSelector(state => state.uiPedanaMenu.isVisible);
    const altezzaPedana = useSelector(state => state.uiPedanaMenu.realAltezza);
    const ombrelloniIsVisible = useSelector(state => state.uiOmbrelloniMenu.isVisible);
    const isSelezioneAutomaticaOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.selezioneMisuraAutomatica);
    const genereOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.genereOmbrellone);
    const tipoOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.tipoOmbrellone);
    const misuraOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.misureOmbrellone);
    const misuraAutomaticaOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.misuraOmbrelloneAutomatica);
    const latoOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.latoOmbrelloni);
    const dataOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.dataOmbrelloni);
    const isParaventiVisible = useSelector(state => state.uiParaventiMenu.isVisible);
    const tipoParaventi = useSelector(state => state.uiParaventiMenu.tipoParavento);
    const latiParaventi = useSelector(state => state.uiParaventiMenu.latiParaventi); 
    const ombrelloniCotrapposti = useSelector(state => state.uiOmbrelloniMenu.ombrelloniContrapposti);
  
    const dispatch = useDispatch();

    const offsetSeparazioneSostegni = 0.028;
    const offsetPedanaSostegni = 0.025;
    const kitPortaHeight = 1.6;
    const kitPortaOffset = 0.02;
    
    const [sostegniAngolari, setSostegniAngolari] = useState([]);
    const [sostegniLato1Array, setSostegniLato1Array] = useState([]);
    const [sostegniLato2Array, setSostegniLato2Array] = useState([]);
    const [sostegniLato3Array, setSostegniLato3Array] = useState([]);
    const [sostegniLato4Array, setSostegniLato4Array] = useState([]);
    const [portaPosition, setPortaPosition] = useState([]); 

    const shapeLato1 = new THREE.Shape();    
    const shapeLato2 = new THREE.Shape(); 
    const shapeLato3 = new THREE.Shape(); 
    const shapeLato4 = new THREE.Shape();

    const extrudeSettings = {
        steps: 2,
        depth: 0.01,
        bevelEnabled: false,
        bevelThickness: 0.005,
        bevelSize: 0.005,
        bevelOffset: -0.003,
        bevelSegments: 1,
    };

    const buffer = useFBO()
    useFrame((state) => {
        state.gl.setRenderTarget(buffer)
        state.gl.render(state.scene, state.camera)
        state.gl.setRenderTarget(null)
    })  

    // Calcola l'altezza dei paraventi dove il laterale cristal inizia
    const calculateHeightParaventi = () => {  
        let misuraParaventi = 0;     
        const paraventiArr = paraventiConfiguration.filter(element => (
            element.meshName.toString() === tipoParaventi.toString()
            ));
            if (paraventiArr.length > 0) {
                misuraParaventi = paraventiArr[0].altezza;
        }                
        return misuraParaventi;       
    }

    // Calcola l'altezza degli ombrelloni dove il laterale cristal termina
    const calculateHeightOmbrelloni = () => {
        let heightOmbrelloni = 0;
        if (tipoOmbrelloni.toString() !== E_TipoOmbrellone.Scegli) {
            const ombrellone = ombrelloniConfiguration.find(el => el.meshSpecificName.toString() === tipoOmbrelloni.toString());
            if (ombrellone) 
                heightOmbrelloni = ombrellone.altezzaLateraleCristal;           
        }
        return heightOmbrelloni;
    }

    // Genera la mesh del laterale
    const generateShape = (shape, firstPoint, lastPoint, heightTop, heightBottom) => {
        shape.moveTo(firstPoint, heightBottom);
        shape.lineTo(lastPoint, heightBottom);
        shape.lineTo(lastPoint, heightTop);
        shape.lineTo(firstPoint, heightTop);
        shape.lineTo(firstPoint, heightBottom);              
        return shape;
    }

    // Genera l'aertura sulla mesh del Cristal in caso di ingresso e calcola la posizione dell'entrata
    const generateShapeIngresso = (shape, firstPoint, lastPoint, heightTop, heightBottom) => {   
        const metaLato = Math.abs(lastPoint.toFixed(2) - firstPoint.toFixed(2))/2;       
        let offset = 0;      
        // Decide su quale punto del lato piazzare l'entrata
        if ((firstPoint > lastPoint || firstPoint < lastPoint)) {
            offset = metaLato;         
            if (ombrelloniCotrapposti) {
                if (latoOmbrelloni.toString() === E_MainLato.Lato1.toString() && (latoIngresso.toString() === E_MainLato.Lato2.toString() || latoIngresso.toString() === E_MainLato.Lato4.toString())) {
                    offset = metaLato/2;
                }
                if (latoOmbrelloni.toString() === E_MainLato.Lato2.toString() && (latoIngresso.toString() === E_MainLato.Lato1.toString() || latoIngresso.toString() === E_MainLato.Lato3.toString())) {
                    offset = metaLato/2;
                }
                if (latoOmbrelloni.toString() === E_MainLato.Lato3.toString() && (latoIngresso.toString() === E_MainLato.Lato2.toString() || latoIngresso.toString() === E_MainLato.Lato4.toString())) {
                    offset = metaLato/2;
                }
                if (latoOmbrelloni.toString() === E_MainLato.Lato4.toString() && (latoIngresso.toString() === E_MainLato.Lato1.toString() || latoIngresso.toString() === E_MainLato.Lato3.toString())) {
                    offset = metaLato/2;
                }
            } 
        } else if ((metaLato >= -0.1 && metaLato <= 0.1)) {
            // Porta sulla metà del lato
            const metaLato = 0;  
            shape.moveTo(firstPoint, heightBottom);
            shape.lineTo(metaLato - 0.5, heightBottom);
            shape.lineTo(metaLato - 0.5, altezzaPedana + 1.65);
            shape.lineTo(metaLato + 0.5, altezzaPedana + 1.65);
            shape.lineTo(metaLato + 0.5, heightBottom);
            shape.lineTo(lastPoint, heightBottom);
            shape.lineTo(lastPoint, heightTop);
            shape.lineTo(firstPoint, heightTop);  
            shape.lineTo(firstPoint, heightBottom);      
            return shape;
        }    
        // Porta su uno dei lati
        shape.moveTo(firstPoint, heightBottom);
        shape.lineTo(firstPoint - 0.5 + offset, heightBottom);
        shape.lineTo(firstPoint - 0.5 + offset, altezzaPedana + 1.65);   
        shape.lineTo(firstPoint + 0.5 + offset, altezzaPedana + 1.65);
        shape.lineTo(firstPoint + 0.5 + offset, heightBottom);
        shape.lineTo(lastPoint, heightBottom);
        shape.lineTo(lastPoint, heightTop);
        shape.lineTo(firstPoint, heightTop);
        shape.lineTo(firstPoint, heightBottom);              
        return shape;
    }
    
    // Funzione di partenza: calcola la posizione dei sostegni sul laterale, a seconda del numero e della posizione degli ombrelloni
    const selectSostegniPoints = () => {  
        const angularsTempArray = [];
        const sostegniTempArray = [];     
        let realMeasureMain = 0;   
        // Sceglie i punti per i potenziali sostegni
        if (dataOmbrelloni.length > 0) {           
            // Se non sono selezionati gli ombrelloni, non fare nulla
            if (!ombrelloniIsVisible || tipoOmbrelloni.toString() === E_TipoOmbrellone.Scegli.toString()) {
                return;
            }            
            // Altrimenti genera i laterali   
            // Calcola la misura di allargamento dell'ombrellone
            let mainDirection = 0;
            if (genereOmbrelloni.toString() !== E_GenereOmbrellone.Centrale.toString() && (latoOmbrelloni.toString() === E_MainLato.Lato1.toString() || latoOmbrelloni.toString() === E_MainLato.Lato3.toString())) {
                mainDirection = larghezza;
            } else if (genereOmbrelloni.toString() !== E_GenereOmbrellone.Centrale.toString() && (latoOmbrelloni.toString() !== E_MainLato.Lato1.toString() || latoOmbrelloni.toString() !== E_MainLato.Lato3.toString())) {
                mainDirection = lunghezza;
            } else if (genereOmbrelloni.toString() === E_GenereOmbrellone.Centrale.toString() && latoOmbrelloni.toString() === E_MainLato.Lato1.toString()) {
                mainDirection = larghezza;
            } else if (genereOmbrelloni.toString() === E_GenereOmbrellone.Centrale.toString() && latoOmbrelloni.toString() === E_MainLato.Lato2.toString()) {
                mainDirection = lunghezza;
            }    
            const ombrelloniNumb = dataOmbrelloni.length;
            const realOmbrNumb = !ombrelloniCotrapposti ? ombrelloniNumb : ombrelloniNumb/2; 
            const enlargmentMeasure = isSelezioneAutomaticaOmbrelloni ? 
                (mainDirection - (dataOmbrelloni[0].mainDimension * realOmbrNumb)) / realOmbrNumb : 
                0; 
            // Calcola la misura reale dell'ombrellone       
            realMeasureMain = dataOmbrelloni[0].mainDimension + enlargmentMeasure;    
            // Posiziona i sostegni 
            const bottom = isPedanaVisible ? altezzaPedana : 0;  
            // Determina i punti in base al lato principale
            if (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) {  
                // Se non ci sono ombrelloni contrapposti...
                if (!ombrelloniCotrapposti) {
                    for (let i=0; i<dataOmbrelloni.length; i++) {                         
                        if (latoOmbrelloni.toString() === E_MainLato.Lato1.toString()) {    
                            sostegniTempArray.push([-lunghezza/2 + dataOmbrelloni[0].secondaryDimension, bottom, dataOmbrelloni[i].position[2] - realMeasureMain/2 + offsetSeparazioneSostegni]);            
                            sostegniTempArray.push([-lunghezza/2 + dataOmbrelloni[0].secondaryDimension, bottom, dataOmbrelloni[i].position[2] + realMeasureMain/2 - offsetSeparazioneSostegni]);
                            sostegniTempArray.push([-lunghezza/2 + offsetPedanaSostegni, bottom, dataOmbrelloni[i].position[2] - realMeasureMain/2 + offsetSeparazioneSostegni]);  
                            sostegniTempArray.push([-lunghezza/2 + offsetPedanaSostegni, bottom, dataOmbrelloni[i].position[2] + realMeasureMain/2 - offsetSeparazioneSostegni]);  
                        } else if (latoOmbrelloni.toString() === E_MainLato.Lato2.toString()) {     
                            sostegniTempArray.push([dataOmbrelloni[i].position[0] - realMeasureMain/2 + offsetSeparazioneSostegni, bottom, -larghezza/2 + dataOmbrelloni[0].secondaryDimension]);
                            sostegniTempArray.push([dataOmbrelloni[i].position[0] + realMeasureMain/2 - offsetSeparazioneSostegni, bottom, -larghezza/2 + dataOmbrelloni[0].secondaryDimension]);
                            sostegniTempArray.push([dataOmbrelloni[i].position[0] - realMeasureMain/2 + offsetSeparazioneSostegni, bottom, -larghezza/2 + offsetPedanaSostegni]);
                            sostegniTempArray.push([dataOmbrelloni[i].position[0] + realMeasureMain/2 - offsetSeparazioneSostegni, bottom, -larghezza/2 + offsetPedanaSostegni]);              
                        } else if (latoOmbrelloni.toString() === E_MainLato.Lato3.toString()) {
                            sostegniTempArray.push([lunghezza/2 - dataOmbrelloni[0].secondaryDimension, bottom, dataOmbrelloni[i].position[2] - realMeasureMain/2 + offsetSeparazioneSostegni]);
                            sostegniTempArray.push([lunghezza/2 - dataOmbrelloni[0].secondaryDimension, bottom, dataOmbrelloni[i].position[2] + realMeasureMain/2 - offsetSeparazioneSostegni]);
                            sostegniTempArray.push([lunghezza/2 - offsetPedanaSostegni, bottom, dataOmbrelloni[i].position[2] - realMeasureMain/2 + offsetSeparazioneSostegni]);  
                            sostegniTempArray.push([lunghezza/2 - offsetPedanaSostegni, bottom, dataOmbrelloni[i].position[2] + realMeasureMain/2 - offsetSeparazioneSostegni]);         
                        } else if (latoOmbrelloni.toString() === E_MainLato.Lato4.toString()) {
                            sostegniTempArray.push([dataOmbrelloni[i].position[0] - realMeasureMain/2 + offsetSeparazioneSostegni, bottom, larghezza/2 - dataOmbrelloni[0].secondaryDimension]);
                            sostegniTempArray.push([dataOmbrelloni[i].position[0] + realMeasureMain/2 - offsetSeparazioneSostegni, bottom, larghezza/2 - dataOmbrelloni[0].secondaryDimension]);
                            sostegniTempArray.push([dataOmbrelloni[i].position[0] - realMeasureMain/2 + offsetSeparazioneSostegni, bottom, larghezza/2 - offsetPedanaSostegni]);
                            sostegniTempArray.push([dataOmbrelloni[i].position[0] + realMeasureMain/2 - offsetSeparazioneSostegni, bottom, larghezza/2 - offsetPedanaSostegni]);
                        }
                    }    
                // Se ci sono ombrelloni contrapposti
                } else if (ombrelloniCotrapposti) {                   
                    for (let i=0; i<dataOmbrelloni.length; i++) {                                              
                        if (latoOmbrelloni.toString() === E_MainLato.Lato1.toString()) { 
                            if (i%2 === 0) {
                                sostegniTempArray.push([-lunghezza/2, bottom, dataOmbrelloni[i].position[2] - realMeasureMain/2 + offsetSeparazioneSostegni]);              
                                sostegniTempArray.push([-lunghezza/2, bottom, dataOmbrelloni[i].position[2] + realMeasureMain/2 - offsetSeparazioneSostegni]);
                                sostegniTempArray.push([lunghezza/2 + offsetPedanaSostegni, bottom, dataOmbrelloni[i].position[2] - realMeasureMain/2 + offsetSeparazioneSostegni]);  
                                sostegniTempArray.push([lunghezza/2 + offsetPedanaSostegni, bottom, dataOmbrelloni[i].position[2] + realMeasureMain/2 - offsetSeparazioneSostegni]);    
                            }   
                        } else if (latoOmbrelloni.toString() === E_MainLato.Lato2.toString()) {  
                            if (i%2 === 0) {   
                                sostegniTempArray.push([dataOmbrelloni[i].position[0] - realMeasureMain/2 + offsetSeparazioneSostegni, bottom, larghezza/2]);
                                sostegniTempArray.push([dataOmbrelloni[i].position[0] + realMeasureMain/2 - offsetSeparazioneSostegni, bottom, larghezza/2]);
                                sostegniTempArray.push([dataOmbrelloni[i].position[0] - realMeasureMain/2 + offsetSeparazioneSostegni, bottom, -larghezza/2 + offsetPedanaSostegni]);
                                sostegniTempArray.push([dataOmbrelloni[i].position[0] + realMeasureMain/2 - offsetSeparazioneSostegni, bottom, -larghezza/2 + offsetPedanaSostegni]);              
                            }
                        } else if (latoOmbrelloni.toString() === E_MainLato.Lato3.toString()) {
                            if (i%2 === 0) {
                                sostegniTempArray.push([-lunghezza/2, bottom, dataOmbrelloni[i].position[2] - realMeasureMain/2 + offsetSeparazioneSostegni]);              
                                sostegniTempArray.push([-lunghezza/2, bottom, dataOmbrelloni[i].position[2] + realMeasureMain/2 - offsetSeparazioneSostegni]);
                                sostegniTempArray.push([lunghezza/2 + offsetPedanaSostegni, bottom, dataOmbrelloni[i].position[2] - realMeasureMain/2 + offsetSeparazioneSostegni]);  
                                sostegniTempArray.push([lunghezza/2 + offsetPedanaSostegni, bottom, dataOmbrelloni[i].position[2] + realMeasureMain/2 - offsetSeparazioneSostegni]);    
                            }
                        } else if (latoOmbrelloni.toString() === E_MainLato.Lato4.toString()) {
                            if (i%2 === 0) {   
                                sostegniTempArray.push([dataOmbrelloni[i].position[0] - realMeasureMain/2 + offsetSeparazioneSostegni, bottom, larghezza/2]);
                                sostegniTempArray.push([dataOmbrelloni[i].position[0] + realMeasureMain/2 - offsetSeparazioneSostegni, bottom, larghezza/2]);
                                sostegniTempArray.push([dataOmbrelloni[i].position[0] - realMeasureMain/2 + offsetSeparazioneSostegni, bottom, -larghezza/2 + offsetPedanaSostegni]);
                                sostegniTempArray.push([dataOmbrelloni[i].position[0] + realMeasureMain/2 - offsetSeparazioneSostegni, bottom, -larghezza/2 + offsetPedanaSostegni]);              
                            }
                        }
                    }                   
                }                
            }   
            // Ombrelloni centrali   
            else if (genereOmbrelloni.toString() === E_GenereOmbrellone.Centrale.toString()) {  
                for (let i=0; i<dataOmbrelloni.length; i++) {      
                    if (latoOmbrelloni.toString() === E_MainLato.Lato1.toString()) {       
                        sostegniTempArray.push([dataOmbrelloni[0].secondaryDimension/2, bottom, dataOmbrelloni[i].position[2] + realMeasureMain/2 - offsetSeparazioneSostegni]);
                        sostegniTempArray.push([-dataOmbrelloni[0].secondaryDimension/2, bottom, dataOmbrelloni[i].position[2] + realMeasureMain/2 - offsetSeparazioneSostegni]);
                        sostegniTempArray.push([dataOmbrelloni[0].secondaryDimension/2, bottom, dataOmbrelloni[i].position[2] - realMeasureMain/2 + offsetSeparazioneSostegni]);
                        sostegniTempArray.push([-dataOmbrelloni[0].secondaryDimension/2, bottom, dataOmbrelloni[i].position[2] - realMeasureMain/2 + offsetSeparazioneSostegni]);
                    } else if (latoOmbrelloni.toString() === E_MainLato.Lato2.toString()) {
                        sostegniTempArray.push([dataOmbrelloni[i].position[0] + realMeasureMain/2 - offsetSeparazioneSostegni, bottom, dataOmbrelloni[0].secondaryDimension/2]);            
                        sostegniTempArray.push([dataOmbrelloni[i].position[0] + realMeasureMain/2 - offsetSeparazioneSostegni, bottom, -dataOmbrelloni[0].secondaryDimension/2]);
                        sostegniTempArray.push([dataOmbrelloni[i].position[0] - realMeasureMain/2 + offsetSeparazioneSostegni, bottom, dataOmbrelloni[0].secondaryDimension/2]);  
                        sostegniTempArray.push([dataOmbrelloni[i].position[0] - realMeasureMain/2 + offsetSeparazioneSostegni, bottom, -dataOmbrelloni[0].secondaryDimension/2]);  
                    }
                }    
            }  
            // Verifica che non ci siano supporti sull'entrata ed eventualmente le sposta
            sostegniTempArray.forEach(element => {  
                if (!isPortaCristalSelected)
                    return;        
                if ((latoOmbrelloni.toString() === E_MainLato.Lato1.toString() || latoOmbrelloni.toString() === E_MainLato.Lato3.toString()) && (latoIngresso.toString() === E_MainLato.Lato1.toString() || latoIngresso.toString() === E_MainLato.Lato3.toString())) {
                    if (element[2] > -0.5 && element[2] < 0) {
                        element[2] = -0.5;                   
                    } else if (element[2] > 0 && element[2] < 0.5) {
                        element[2] = 0.5;    
                    }
                } else if ((latoOmbrelloni.toString() === E_MainLato.Lato2.toString() || latoOmbrelloni.toString() === E_MainLato.Lato4.toString()) && (latoIngresso.toString() === E_MainLato.Lato2.toString() || latoIngresso.toString() === E_MainLato.Lato4.toString())) {
                    if (element[0] > -0.5 && element[0] < 0) {
                        element[0] = -0.5;                   
                    } else if (element[0] > 0 && element[0] < 0.5) {
                        element[0] = 0.5;    
                    }            
                }
            });   
            // Seleziona le posizioni dei sostegni angolari
            let a1_2 = 0;  
            let a2_3 = 0;    
            let a1_4 = 0;  
            let a3_4 = 0;  
            if (sostegniTempArray.length > 0) {
                a1_2 = sostegniTempArray.reduce((pre, cur) => (pre[0] <= cur[0] && pre[2] <= cur[2]) ? pre : cur);  
                a2_3 = sostegniTempArray.reduce((pre, cur) => (pre[0] >= cur[0] && pre[2] <= cur[2]) ? pre : cur);    
                a1_4 = sostegniTempArray.reduce((pre, cur) => (pre[0] <= cur[0] && pre[2] >= cur[2]) ? pre : cur);  
                a3_4 = sostegniTempArray.reduce((pre, cur) => (pre[0] >= cur[0] && pre[2] >= cur[2]) ? pre : cur);  
            } 
            angularsTempArray.push(a1_2);
            angularsTempArray.push(a2_3);
            angularsTempArray.push(a1_4);
            angularsTempArray.push(a3_4);    
        }
        divideSostegni(sostegniTempArray, angularsTempArray, realMeasureMain);
    }

    // Seconda funzione: distribuisce i sostegni nei vari array, visibili a seconda dei lati selezionati
    const divideSostegni = (sostegniTempArray, angularsTempArray, realMeasureMain) => {         
        // Distribuisce i sostegni nei relativi lati array
        const lato1 = sostegniTempArray.filter(element => element[0] === angularsTempArray[0][0]);
        const lato2 = sostegniTempArray.filter(element => element[2] === angularsTempArray[0][2]);
        const lato3 = sostegniTempArray.filter(element => element[0] === angularsTempArray[1][0]);
        const lato4 = sostegniTempArray.filter(element => element[2] === angularsTempArray[2][2]);

        setSostegniLato1Array(lato1);
        setSostegniLato2Array(lato2);
        setSostegniLato3Array(lato3);
        setSostegniLato4Array(lato4);
        setSostegniAngolari(angularsTempArray);    
        
        // Seleziona solo i sostegni attualmente selezionati
        const tempSelectedArray = [];    
        for (let i=0; i<latiCristal.length; i++) {
            if (latiCristal[i].cristal) {
                if (latiCristal[i].lato.toString() === E_MainLato.Lato1.toString())              
                    tempSelectedArray.push(...lato1)        
                else if (latiCristal[i].lato.toString() === E_MainLato.Lato2.toString())            
                    tempSelectedArray.push(...lato2)       
                else if (latiCristal[i].lato.toString() === E_MainLato.Lato3.toString())                              
                    tempSelectedArray.push(...lato3)              
                else if (latiCristal[i].lato.toString() === E_MainLato.Lato4.toString())                              
                    tempSelectedArray.push(...lato4)                
            }
        }
        // Verifica che non ci siano doppioni (sostegni contati 2 volte) ed eliminali
        for (let i=0; i<tempSelectedArray.length; i++) {
            const selectedElement = tempSelectedArray[i];
            for (let d=0; d<tempSelectedArray.length; d++) {
                if (tempSelectedArray[d] === selectedElement && d !== i) {
                    tempSelectedArray.splice(d,1);                  
                } 
            }
        }
        // Aggiunge i sostegni laterali per gli ombrelloni contrapposti
        const bottom = isPedanaVisible ? altezzaPedana : 0;  
        if (ombrelloniCotrapposti) {         
            if(latoOmbrelloni.toString() === E_MainLato.Lato1.toString() || latoOmbrelloni.toString() === E_MainLato.Lato3.toString()) {
                const tArray2 = [];
                tArray2.push([-offsetSeparazioneSostegni, bottom, dataOmbrelloni[0].position[2] - realMeasureMain/2]);
                tArray2.push([offsetSeparazioneSostegni, bottom, dataOmbrelloni[0].position[2] - realMeasureMain/2]);
                tArray2.concat(sostegniLato2Array);
                setSostegniLato2Array(tArray2);
                const tArray4 = [];
                tArray4.push([-offsetSeparazioneSostegni, bottom, dataOmbrelloni[dataOmbrelloni.length-1].position[2] + realMeasureMain/2]);
                tArray4.push([offsetSeparazioneSostegni, bottom, dataOmbrelloni[dataOmbrelloni.length-1].position[2] + realMeasureMain/2]);
                tArray4.concat(sostegniLato4Array);
                setSostegniLato4Array(tArray4);  
            }
            else if(latoOmbrelloni.toString() === E_MainLato.Lato2.toString() || latoOmbrelloni.toString() === E_MainLato.Lato4.toString()) {
                const tArray1 = [];
                tArray1.push([dataOmbrelloni[0].position[0] - realMeasureMain/2, bottom, -offsetSeparazioneSostegni]);
                tArray1.push([dataOmbrelloni[0].position[0] - realMeasureMain/2, bottom, offsetSeparazioneSostegni]);
                tArray1.concat(sostegniLato1Array);
                setSostegniLato1Array(tArray1);
                const tArray3 = [];
                tArray3.push([dataOmbrelloni[dataOmbrelloni.length-1].position[0] + realMeasureMain/2, bottom, -offsetSeparazioneSostegni]);
                tArray3.push([dataOmbrelloni[dataOmbrelloni.length-1].position[0] + realMeasureMain/2, bottom, offsetSeparazioneSostegni]);
                tArray3.concat(sostegniLato3Array);
                setSostegniLato3Array(tArray3);  
            }
        }
        // Aggiorna il totale dei sostegni
        if (!ombrelloniCotrapposti) {
            dispatch(handleTotaleSostegni(tempSelectedArray.length)); 
        }
        else {
            dispatch(handleTotaleSostegni(tempSelectedArray.length+4)); 
        }
    }
    
    // Stabilisce la posizione per posizionare la porta del laterale cristal, in base alle varie configurazioni degli ombrelloni
    const generatePorta = () => {     
        // Se non ci sono dati degli ombrelloni, esci senza piazzare
        if (dataOmbrelloni.length <= 0) {      
            return;
        } 
        // Genera la porta in base alla posizioni selezionate
        // Se non è selezionato l'ingresso, informa l'utente
        if (isPortaCristalSelected && latoIngresso.toString() === E_MainLato.Scegli.toString()) {
            dispatch(showMessage("Scegli l'ingresso per piazzare la porta del Laterale Cristal"));      
            return;  
        } 
        dispatch(deleteMessage());     
        // Ombrelloni laterali
        if (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) {
            switch(latoIngresso.toString()) {
                case E_MainLato.Lato1.toString():    
                    if (latoOmbrelloni.toString() === E_MainLato.Lato1.toString())
                        setPortaPosition([-lunghezza/2, 0]);
                    else if (latoOmbrelloni.toString() === E_MainLato.Lato2.toString())
                        setPortaPosition([sostegniAngolari[0][0], -larghezza/2 + kitPortaOffset + dataOmbrelloni[0].secondaryDimension/2]);
                    else if (latoOmbrelloni.toString() === E_MainLato.Lato3.toString())
                        !ombrelloniCotrapposti ? setPortaPosition([lunghezza/2 - dataOmbrelloni[0].secondaryDimension, 0]) : setPortaPosition([-dataOmbrelloni[dataOmbrelloni.length-1].secondaryDimension, 0]);
                    else if (latoOmbrelloni.toString() === E_MainLato.Lato4.toString())
                        !ombrelloniCotrapposti ? setPortaPosition([sostegniAngolari[0][0], larghezza/2 - kitPortaOffset - dataOmbrelloni[0].secondaryDimension/2]) : setPortaPosition([sostegniAngolari[0][0], kitPortaOffset - dataOmbrelloni[0].secondaryDimension/2]);       
                break;
                case E_MainLato.Lato2.toString():       
                    if (latoOmbrelloni.toString() === E_MainLato.Lato1.toString())
                        setPortaPosition([-lunghezza/2 + kitPortaOffset + dataOmbrelloni[0].secondaryDimension/2, sostegniAngolari[0][2]]);
                    else if (latoOmbrelloni.toString() === E_MainLato.Lato2.toString())
                        setPortaPosition([0, -larghezza/2]);
                    else if (latoOmbrelloni.toString() === E_MainLato.Lato3.toString())
                        !ombrelloniCotrapposti ? setPortaPosition([lunghezza/2 - kitPortaOffset - dataOmbrelloni[0].secondaryDimension/2, sostegniAngolari[0][2]]) : setPortaPosition([kitPortaOffset - dataOmbrelloni[0].secondaryDimension/2, sostegniAngolari[0][2]]);
                    else if (latoOmbrelloni.toString() === E_MainLato.Lato4.toString())
                        setPortaPosition([0, sostegniAngolari[0][2]]);          
                break;
                case E_MainLato.Lato3.toString():                
                    if (latoOmbrelloni.toString() === E_MainLato.Lato1.toString())
                        !ombrelloniCotrapposti ? setPortaPosition([-lunghezza/2 + dataOmbrelloni[0].secondaryDimension, 0]) : setPortaPosition([dataOmbrelloni[0].secondaryDimension, 0]);
                    else if (latoOmbrelloni.toString() === E_MainLato.Lato2.toString())
                        setPortaPosition([sostegniAngolari[1][0], -larghezza/2 + kitPortaOffset + dataOmbrelloni[0].secondaryDimension/2]);
                    else if (latoOmbrelloni.toString() === E_MainLato.Lato3.toString())
                        setPortaPosition([lunghezza/2, 0]);
                    else if (latoOmbrelloni.toString() === E_MainLato.Lato4.toString())
                        !ombrelloniCotrapposti ? setPortaPosition([sostegniAngolari[1][0], larghezza/2 - kitPortaOffset - dataOmbrelloni[0].secondaryDimension/2]) : setPortaPosition([sostegniAngolari[1][0], kitPortaOffset - dataOmbrelloni[0].secondaryDimension/2]);       
                break;
                case E_MainLato.Lato4.toString():                
                    if (latoOmbrelloni.toString() === E_MainLato.Lato1.toString())
                        setPortaPosition([-lunghezza/2 + kitPortaOffset + dataOmbrelloni[0].secondaryDimension/2, sostegniAngolari[2][2]]);
                    else if (latoOmbrelloni.toString() === E_MainLato.Lato2.toString())
                        !ombrelloniCotrapposti ? setPortaPosition([0, -larghezza/2 + dataOmbrelloni[0].secondaryDimension]) : setPortaPosition([0, dataOmbrelloni[0].secondaryDimension]);
                    else if (latoOmbrelloni.toString() === E_MainLato.Lato3.toString())
                        !ombrelloniCotrapposti ? setPortaPosition([lunghezza/2 - kitPortaOffset - dataOmbrelloni[0].secondaryDimension/2, sostegniAngolari[2][2]]) : setPortaPosition([kitPortaOffset - dataOmbrelloni[0].secondaryDimension/2, sostegniAngolari[2][2]]);
                    else if (latoOmbrelloni.toString() === E_MainLato.Lato4.toString())
                        setPortaPosition([0, larghezza/2]);      
                break;
                default:
                    if (latoOmbrelloni.toString() === E_MainLato.Lato1.toString())
                        setPortaPosition([-lunghezza/2, 0]);
                    else if (latoOmbrelloni.toString() === E_MainLato.Lato2.toString())
                        setPortaPosition([sostegniAngolari[0][0], -larghezza/2 + kitPortaOffset + dataOmbrelloni[0].secondaryDimension/2]);
                    else if (latoOmbrelloni.toString() === E_MainLato.Lato3.toString())
                        setPortaPosition([lunghezza/2 - dataOmbrelloni[0].secondaryDimension, 0]);
                    else if (latoOmbrelloni.toString() === E_MainLato.Lato4.toString())
                        setPortaPosition([sostegniAngolari[0][0], larghezza/2 - kitPortaOffset - dataOmbrelloni[0].secondaryDimension/2]);       
                break;
            }       
        } else if (genereOmbrelloni.toString() === E_GenereOmbrellone.Centrale.toString()) {
            // Ombrelloni centrali
            switch(latoIngresso.toString()) {
                case E_MainLato.Lato1.toString():  
                    setPortaPosition([sostegniAngolari[0][0], 0]);      
                break;
                case E_MainLato.Lato2.toString():      
                    setPortaPosition([0, sostegniAngolari[0][2]]);       
    
                break;
                case E_MainLato.Lato3.toString():                
                    setPortaPosition([sostegniAngolari[1][0], 0]);       
                break;
                case E_MainLato.Lato4.toString():                
                    setPortaPosition([0, sostegniAngolari[2][2]]);       
                break;
                default:
                    setPortaPosition([sostegniAngolari[0][0], 0]);   
                break;
            }     
        }      
    }

    // Genera le meshes dei laterali cristal a seconda dei lati selezionati
    const generateLateraleCristal = (indexLato) => {     
        // Se non sono selezionati gli ombrelloni, non fare nulla
        if (!ombrelloniIsVisible || tipoOmbrelloni.toString() === E_TipoOmbrellone.Scegli.toString() || 
            ((genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) && latoOmbrelloni.toString() === E_MainLato.Scegli.toString())) {
            return;
        } 
        // Altrimenti genera i laterali    
        // Misure
        const offsetParaventiDistance = 0.03;
        let heightTop = calculateHeightOmbrelloni();
        if (isPedanaVisible) heightTop = calculateHeightOmbrelloni() + altezzaPedana;    
        let heightBottom1 = isPedanaVisible ? altezzaPedana : 0;
        let heightBottom2 = isPedanaVisible ? altezzaPedana : 0;
        let heightBottom3 = isPedanaVisible ? altezzaPedana : 0;
        let heightBottom4 = isPedanaVisible ? altezzaPedana : 0;      
        if (isParaventiVisible) {      
            if (latiParaventi.find(element => element.lato.toString() === E_MainLato.Lato1.toString()).parav && Math.abs(sostegniAngolari[0][0]) >= lunghezza/2 - offsetParaventiDistance)
                heightBottom1 += calculateHeightParaventi();
            if (latiParaventi.find(element => element.lato.toString() === E_MainLato.Lato2.toString()).parav && Math.abs(sostegniAngolari[1][2]) >= larghezza/2 - offsetParaventiDistance)
                heightBottom2 += calculateHeightParaventi();
            if (latiParaventi.find(element => element.lato.toString() === E_MainLato.Lato3.toString()).parav && Math.abs(sostegniAngolari[1][0]) >= lunghezza/2 - offsetParaventiDistance)
                heightBottom3 += calculateHeightParaventi();
            if (latiParaventi.find(element => element.lato.toString() === E_MainLato.Lato4.toString()).parav && Math.abs(sostegniAngolari[2][2]) >= larghezza/2 - offsetParaventiDistance)
                heightBottom4 += calculateHeightParaventi();        
        }       

        // Genera i punti sul lato principale     
        if (dataOmbrelloni.length > 0) {     
            // Verifica tutti i lati
            switch(indexLato) {
                case 1: {       
                    if (isPortaCristalSelected && latoIngresso.toString() === E_MainLato.Lato1.toString())          
                        return generateShapeIngresso(shapeLato1, sostegniAngolari[0][2], sostegniAngolari[2][2], heightTop, heightBottom1, latoOmbrelloni);                 
                    else                            
                        return generateShape(shapeLato1, sostegniAngolari[0][2], sostegniAngolari[2][2], heightTop, heightBottom1);
                }                        
                case 2: {  
                    if (isPortaCristalSelected && latoIngresso.toString() === E_MainLato.Lato2.toString())                   
                        return generateShapeIngresso(shapeLato2, sostegniAngolari[0][0], sostegniAngolari[1][0], heightTop, heightBottom2, latoOmbrelloni);           
                    else
                        return generateShape(shapeLato2, sostegniAngolari[0][0], sostegniAngolari[1][0], heightTop, heightBottom2);     
                }               
                case 3: {  
                    if (isPortaCristalSelected && latoIngresso.toString() === E_MainLato.Lato3.toString())                
                        return generateShapeIngresso(shapeLato3, sostegniAngolari[1][2], sostegniAngolari[3][2], heightTop, heightBottom3, latoOmbrelloni);
                    else
                        return generateShape(shapeLato3, sostegniAngolari[1][2], sostegniAngolari[3][2], heightTop, heightBottom3);                                    
                }              
                case 4: {
                    if (isPortaCristalSelected && latoIngresso.toString() === E_MainLato.Lato4.toString())                  
                        return generateShapeIngresso(shapeLato4, sostegniAngolari[2][0], sostegniAngolari[3][0], heightTop, heightBottom4, latoOmbrelloni);
                    else
                        return generateShape(shapeLato4, sostegniAngolari[2][0], sostegniAngolari[3][0], heightTop, heightBottom4); 
                }  
                default: {
                    if (isPortaCristalSelected && latoIngresso.toString() === E_MainLato.Lato1.toString())          
                        return generateShapeIngresso(shapeLato1, sostegniAngolari[0][2], sostegniAngolari[2][2], heightTop, heightBottom1, latoOmbrelloni);                 
                    else                            
                        return generateShape(shapeLato1, sostegniAngolari[0][2], sostegniAngolari[2][2], heightTop, heightBottom1);
                }   
            }         
        }  
    }    

    // Aggiorna i laterali
    useEffect(() => {          
        selectSostegniPoints();           
    }, [isCristalSelected, 
        latiCristal, 
        lunghezza, 
        larghezza, 
        latoIngresso,
        latoOmbrelloni, 
        isSelezioneAutomaticaOmbrelloni, 
        misuraAutomaticaOmbrelloni, 
        misuraOmbrelloni, 
        genereOmbrelloni,
        tipoOmbrelloni, 
        dataOmbrelloni, 
        isPedanaVisible, 
        altezzaPedana,
        isParaventiVisible,
        latiParaventi,
        isPortaCristalSelected,    
    ]); 
    
    // Aggiorna la mesh della porta
    useEffect(() => {
        if (sostegniAngolari.length > 0 && isPortaCristalSelected)
            generatePorta();        
    }, [isCristalSelected, sostegniAngolari]);

    return (
        <>
            {isCristalSelected && 
                <group>          
                    {/* Laterali Cristal */}
                    {latiCristal[0].cristal &&
                    latoOmbrelloni.toString() !== E_MainLato.Scegli.toString() && sostegniAngolari.length > 0 && 
                    <mesh position={[sostegniAngolari[0][0], 0, 0]} rotation={[0, -Math.PI/2, 0]}>
                            <extrudeGeometry args={[generateLateraleCristal(1), extrudeSettings]} />
                            <meshPhongMaterial emissive={"#e5e5e5"} opacity={0.5} transparent side={THREE.DoubleSide}/>   
                    </mesh>}   
                    {latiCristal[1].cristal &&
                    latoOmbrelloni.toString() !== E_MainLato.Scegli.toString() && sostegniAngolari.length > 0 && 
                    <mesh position={[0, 0, sostegniAngolari[0][2]]} rotation={[0, 0, 0]}>
                            <extrudeGeometry args={[generateLateraleCristal(2), extrudeSettings]} />  
                            <meshPhongMaterial emissive={"#e5e5e5"} opacity={0.5} transparent side={THREE.DoubleSide}/>   
                    </mesh>}
                    {latiCristal[2].cristal &&
                    latoOmbrelloni.toString() !== E_MainLato.Scegli.toString() && sostegniAngolari.length > 0 && 
                    <mesh position={[sostegniAngolari[3][0], 0, 0]} rotation={[0, -Math.PI/2, 0]}>
                            <extrudeGeometry args={[generateLateraleCristal(3), extrudeSettings]} />  
                            <meshPhongMaterial emissive={"#e5e5e5"} opacity={0.5} transparent side={THREE.DoubleSide}/>   
                    </mesh>}
                    {latiCristal[3].cristal &&
                    latoOmbrelloni.toString() !== E_MainLato.Scegli.toString() && sostegniAngolari.length > 0 && 
                    <mesh position={[0, 0, sostegniAngolari[2][2]]} rotation={[0, 0, 0]}>
                            <extrudeGeometry args={[generateLateraleCristal(4), extrudeSettings]} />  
                            <meshPhongMaterial emissive={"#e5e5e5"} opacity={0.5} transparent side={THREE.DoubleSide}/>   
                    </mesh>}   
                    {/* Sostegni Laterali */}
                    {latiCristal.find(element => element.lato.toString() === E_MainLato.Lato1.toString()).cristal &&
                    sostegniLato1Array.map((element, index) => (
                        <AstaSostegno key={`asta_sostegno_lato1_${index}`} posizione={element} altezzaAsta={calculateHeightOmbrelloni()}/>
                    ))}  
                    {latiCristal.find(element => element.lato.toString() === E_MainLato.Lato2.toString()).cristal &&
                    sostegniLato2Array.map((element, index) => (
                        <AstaSostegno key={`asta_sostegno_lato2_${index}`} posizione={element} altezzaAsta={calculateHeightOmbrelloni()}/>
                    ))}  
                    {latiCristal.find(element => element.lato.toString() === E_MainLato.Lato3.toString()).cristal &&
                    sostegniLato3Array.map((element, index) => (
                        <AstaSostegno key={`asta_sostegno_lato3_${index}`} posizione={element} altezzaAsta={calculateHeightOmbrelloni()}/>
                    ))}
                    {latiCristal.find(element => element.lato.toString() === E_MainLato.Lato4.toString()).cristal &&
                    sostegniLato4Array.map((element, index) => (
                        <AstaSostegno key={`asta_sostegno_lato4_${index}`} posizione={element} altezzaAsta={calculateHeightOmbrelloni()}/>
                    ))} 
                    {/* Kit Porta Cristal */}
                    {isPortaCristalSelected && latiCristal.find(element => element.lato.toString() === E_MainLato.Lato1.toString()).cristal && latoIngresso.toString() === E_MainLato.Lato1.toString() && 
                        ((genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) && latoOmbrelloni.toString() !== E_MainLato.Scegli.toString()) &&
                        <KitPortaCristal altezzaPorta={kitPortaHeight} position={[portaPosition[0], 0, portaPosition[1]]} rotationCylinder={[0, Math.PI/2, Math.PI/2]}/> 
                    }                   
                    {isPortaCristalSelected && latiCristal.find(element => element.lato.toString() === E_MainLato.Lato2.toString()).cristal && latoIngresso.toString() === E_MainLato.Lato2.toString() &&
                        ((genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) && latoOmbrelloni.toString() !== E_MainLato.Scegli.toString()) &&
                        <KitPortaCristal altezzaPorta={kitPortaHeight} position={[portaPosition[0], 0, portaPosition[1]]} rotationCylinder={[0, 0, Math.PI/2]}/> 
                    }
                     {isPortaCristalSelected && latiCristal.find(element => element.lato.toString() === E_MainLato.Lato3.toString()).cristal && latoIngresso.toString() === E_MainLato.Lato3.toString() &&
                        ((genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) && latoOmbrelloni.toString() !== E_MainLato.Scegli.toString()) &&
                        <KitPortaCristal altezzaPorta={kitPortaHeight} position={[portaPosition[0], 0, portaPosition[1]]} rotationCylinder={[0, Math.PI/2, Math.PI/2]}/> 
                    }
                    {isPortaCristalSelected && latiCristal.find(element => element.lato.toString() === E_MainLato.Lato4.toString()).cristal && latoIngresso.toString() === E_MainLato.Lato4.toString() &&
                        ((genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) && latoOmbrelloni.toString() !== E_MainLato.Scegli.toString()) &&
                        <KitPortaCristal altezzaPorta={kitPortaHeight} position={[portaPosition[0], 0, portaPosition[1]]} rotationCylinder={[0, 0, Math.PI/2]}/> 
                    }  
                </group>        
            }
        </>
    )
}
